exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chipContainer{margin-bottom:10px}.chipContainer .chip{transition:none;cursor:pointer}.chipListContainer{overflow-y:auto;max-height:300px}.sortable-chosen{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ChipEditor.vue
// module id = 213
// module chunks = 11